import { render, staticRenderFns } from "./StakeModal.vue?vue&type=template&id=7f533b33&scoped=true&"
import script from "./StakeModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StakeModal.vue?vue&type=style&index=0&id=7f533b33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f533b33",
  null
  
)

export default component.exports